import {Dialog, DialogActions, DialogTitle, Stack, styled} from '@mui/material';

const StyledDialog = styled(Dialog)`
	max-width: 392px;
	margin: auto;

	& .MuiDialog-paper {
		margin: 16px;
	}

	${({theme}) => theme.breakpoints.up('sm')} {
		& .MuiDialog-paper {
			margin: 32px;
		}
	}
`;

const StyledDialogHeader = styled(DialogTitle)`
	padding: 16px 24px;
	background-color: ${({theme}) => theme.palette.primary.main};
	color: ${({theme}) => theme.palette.common.white};
`;

const StyledDialogActions = styled(DialogActions)`
	border-top: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
`;

const StyledStack = styled(Stack)`
	width: 100%;
	gap: 8px;
	padding-inline: 8px;
`;

export {StyledDialog, StyledDialogHeader, StyledDialogActions, StyledStack};
